<div class="row">
  <div class="col-12">
    <div class="logo-delcorp">
      <span [routerLink]="['']">
        <fa-icon [icon]="['fas', 'arrow-left']" class="arrow-atras" style="cursor: pointer;"></fa-icon>
      </span>
      <figure class="figure">
        <img class="figure-img" alt={{logo.alt}} src={{logo.url}} style="margin-top:15px;width: 200px;">
      </figure>
    </div>
  </div>
</div>

<div class="content">
  <form (ngSubmit)="registrar()" [formGroup]="registroForm" class="form form-registro">
    <!-- <div class="col-lg-12 col-md-12 col-12 ">
          <h6 style="text-align: center;font-weight: bolder;" *ngIf="codcliente== 'NXVLEVEL'">   Registro para Usuario PARTICULAR </h6>
          <br>
      <div class="mb-3">
        <div class="input-group">

          <input type="text" [(ngModel)]="objDatosFB.first_name" class="form-control" placeholder="Nombres *"
            formControlName="txtNombre" [disabled]="true">
          <div class="exclamation"
            *ngIf="fRegistro.txtNombre.invalid && (fRegistro.txtNombre.dirty || fRegistro.txtNombre.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
              *ngIf="fRegistro.txtNombre.errors.required"></fa-icon>
          </div>
        </div>
      </div>
    </div>


    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="mb-3">
        <div class="input-group">

          <input type="text" [(ngModel)]="objDatosFB.last_name" class="form-control" placeholder="Apellido Paterno*"
            formControlName="txtApellidoPaterno" [disabled]="true">
          <div class="exclamation"
            *ngIf="fRegistro.txtApellidoPaterno.invalid && (fRegistro.txtApellidoPaterno.dirty || fRegistro.txtApellidoPaterno.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
              *ngIf="fRegistro.txtApellidoPaterno.errors.required"></fa-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="mb-3">
        <div class="input-group">

          <input type="text" class="form-control" placeholder="Apellido Materno" formControlName="txtApellidoMaterno" [disabled]="true">
          <div class="exclamation"
            *ngIf="fRegistro.txtApellidoMaterno.invalid && (fRegistro.txtApellidoMaterno.dirty || fRegistro.txtApellidoMaterno.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
              *ngIf="fRegistro.txtApellidoMaterno.errors.required"></fa-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12 ">

      <div class="input-group mb-3">
        <input appSoloNumeros="true" type="text" class="form-control" placeholder={{txtDNI}} formControlName="txtDNI" minlength="8" maxlength="10" [disabled]="true">
        <div class="exclamation"
          *ngIf="fRegistro.txtDNI.invalid && (fRegistro.txtDNI.dirty || fRegistro.txtDNI.touched)">
          <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
            *ngIf="fRegistro.txtDNI.errors.required"></fa-icon>
        </div>
      </div>

    </div>


    <div class="col-lg-12 col-md-12 col-12">
      <div class="input-group mb-3">
        <select [(ngModel)]="paisCode" id="selectPais" class="form-control" name="repeatSelect"
          formControlName="txtPais" required [disabled]="true">
          <option [ngValue]="sel.Code" *ngFor="let sel of pais">{{sel.Name}}</option>
        </select>


      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-12" style="padding: 0px; display: inline-flex;">



      <div class="col-lg-12 col-md-12 col-12 ">
        <div class="input-group  mb-3">
          <input appSoloNumeros="true" type="text" maxlength="13" class="form-control" placeholder="Celular *"
            formControlName="txtTlf"  [disabled]="true">
          <div class="exclamation"
            *ngIf="fRegistro.txtTlf.invalid && (fRegistro.txtTlf.dirty || fRegistro.txtTlf.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" tooltip="Campo requerido" placement="top"
              *ngIf="fRegistro.txtTlf.errors.required"></fa-icon>
          </div>
        </div>
      </div>
    </div>




 -->
 <div class="col-lg-12 col-md-12 col-12 ">

  <div class="mb-3">
    <div class="input-group">
      <!-- formControlName="txtEmail" -->
      <input type="email" [value]="objDatosFB.email" class="form-control" placeholder="Correo *"
     [disabled]="true" id="correo">
      <div class="exclamation"
        *ngIf="fRegistro.txtEmail.invalid && (fRegistro.txtEmail.dirty || fRegistro.txtEmail.touched)">
        <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
          *ngIf="fRegistro.txtEmail.errors.required"></fa-icon>
      </div>
    </div>
  </div>

</div>

    <div class="col-lg-12 col-md-12 col-12 ">
      <div class="mb-3">
        <div class="input-group">
          <div style="    flex: 1 1 100%;">
            <input type="password" class="form-control" placeholder="Clave *" maxlength="30"
              formControlName="txtClave" *ngIf="!showPassword">
            <input type="text" class="form-control" placeholder="Clave *" formControlName="txtClave" maxlength="30"
              *ngIf="showPassword">
          </div>
          <div class="eye">
            <fa-icon *ngIf="!showPassword" [icon]="['far', 'eye']" (click)="toggleShowPassword()"></fa-icon>
            <fa-icon *ngIf="showPassword" [icon]="['far', 'eye-slash']" (click)="toggleShowPassword()"></fa-icon>

          </div>
          <div class="exclamation"
            *ngIf="fRegistro.txtClave.invalid && (fRegistro.txtClave.dirty || fRegistro.txtClave.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
              *ngIf="fRegistro.txtClave.errors.required"></fa-icon>
          </div>
        </div>
      </div>
    </div>




    <div class="col-lg-12 col-md-12 col-12">
      <div class="" *ngIf="showButtonGA; else solicitarButtonGenerica">
      <button (click)="sendRegistrar()" id="btnRegistrarUsuario" type="submit" class="btn  btn-block uk-link-reset widget-large uk-text-center uk-flex uk-flex-center"
        [ngClass]=" registroForm.invalid  ? 'btn-secondary' : 'btn-primary'  "
        [disabled]="registroForm.invalid ||  btnRegistrarUsuarioDisabled" >


        <span [ngSwitch]="showBtnRegistrarUsuario">
          <span *ngSwitchCase="1">
            REGISTRAR
          </span>
          <span *ngSwitchCase="2">
            <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon>
          </span>
          <span *ngSwitchCase="3">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
          </span>
          <span *ngSwitchCase="4">
            <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
          </span>
        </span>
      </button>
    </div>

    <ng-template #solicitarButtonGenerica>
      <button id="btnRegistrarUsuario" type="submit" class="btn  btn-block uk-link-reset widget-large uk-text-center uk-flex uk-flex-center" >


      <span [ngSwitch]="showBtnRegistrarUsuario">
        <span *ngSwitchCase="1">
          REGISTRAR
        </span>
        <span *ngSwitchCase="2">
          <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon>
        </span>
        <span *ngSwitchCase="3">
          <fa-icon [icon]="['fas', 'check']"></fa-icon>
        </span>
        <span *ngSwitchCase="4">
          <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
        </span>
      </span>
    </button>

  </ng-template>

      <button *ngIf="inicioFb" type="button" class="btn btn-facebook text-white btn-block" (click)="obtenerDatosFB()"
        [disabled]="btnDisabledCFB">
        <fa-icon [icon]="['fab', 'facebook-square']" style="font-size: 1rem !important; padding-right: 5px; ">
        </fa-icon>
        <span [ngSwitch]="showBtnConectarFB">
          <span *ngSwitchCase="1">
            CONECTARSE CON FACEBOOK
          </span>
          <span *ngSwitchCase="2">
            CONECTARSE CON FACEBOOK
            <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon>
          </span>
          <span *ngSwitchCase="3">
            CONECTARSE CON FACEBOOK
            <fa-icon [icon]="['fas', 'check']" style="margin-left: 5px;"></fa-icon>
          </span>
          <span *ngSwitchCase="4">
            CONECTARSE CON FACEBOOK
            <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
          </span>
        </span>
      </button>
    </div>

  </form>
</div>
<script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/4710847.js"></script>
